export const ACCEPTED = 202
export const MIN_ERROR_STATUS = 400
export const BAD_REQUEST = 400
export const UNAUTHORIZED = 401
export const FORBIDDEN = 403
export const UNPROCESSABLE_ENTITY = 422
